import { useEffect, useState } from "react";
import { api, appUserAuth } from "./api";

export const AUTH_EVENT = "exodus:auth";
export const OPEN_GATE_EVENT = "exodus:open-gate";

export const openGate = () => window.dispatchEvent(new Event(OPEN_GATE_EVENT));

export function visitorId() {
  let vid = localStorage.getItem("ex_visitor_id");
  if (!vid) { vid = `v_${Math.random().toString(36).slice(2)}${Date.now().toString(36)}`; localStorage.setItem("ex_visitor_id", vid); }
  return vid;
}

export const gateEvent = (event, tool) => api.post("/gate/event", { event, tool, visitor_id: visitorId() }).catch(() => {});

export function useAppAuthed() {
  const [authed, setAuthed] = useState(appUserAuth.isLoggedIn());
  useEffect(() => {
    const on = () => setAuthed(appUserAuth.isLoggedIn());
    window.addEventListener(AUTH_EVENT, on);
    return () => window.removeEventListener(AUTH_EVENT, on);
  }, []);
  return authed;
}
